import type { NextRequest } from "@/modules/fetch/types"

import { getTracingLogData } from "./fetchAndMonitor"
import { logger } from "./logger"

export async function logServerPromise<T>(
  id: string,
  promise: Promise<T>,
  options: {
    data?: Record<string, unknown>
    nextRequest?: NextRequest
  } = {}
): Promise<T> {
  if (process.env.LOG_SERVER_PROMISE !== "true" || typeof window !== "undefined") {
    return promise
  }

  const prefixedId = `promise ${id}`
  const start = new Date()
  const tracingLogData = getTracingLogData(options.nextRequest)

  return promise
    .then((...args) => {
      const stop = new Date()
      const duration = stop.valueOf() - start.valueOf()

      logger.info(
        {
          ...(options?.data || {}),
          ...tracingLogData,
          request_time: duration / 1000,
        },
        prefixedId
      )

      return Promise.resolve(...args)
    })
    .catch(err => {
      const stop = new Date()
      const duration = stop.valueOf() - start.valueOf()

      logger.error(
        {
          ...(options?.data || {}),
          ...tracingLogData,
          error: err.message,
          request_time: duration / 1000,
        },
        prefixedId
      )

      throw err
    })
}
